import { useState } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import AvatarUploader from '../../../../../UI/AvatarUploader'

import styles from '../style.module.scss'

import http from '../../../../../shared/http'
import { TApi } from '../../../../../shared/const'
import { updateProfile } from '../../../../../redux/ducks/user'
import { useAvatarUrl } from '../../../../../shared/useAvatarUrls'

function AvatarPhoto(props) {
	const { t } = useTranslation()
	const [laedt, setLaedt] = useState(false)
	const avatarSrc = useAvatarUrl(props.avatarHashName)

	// Die Datei kommt fertig zugeschnitten aus dem Fenster; Format und Größe
	// hat der Uploader bereits geprüft.
	const handleSelect = file => {
		const form = new FormData()
		form.append('avatar', file)

		setLaedt(true)

		// Kein eigener Vorschau-Zustand: Der neue Dateiname landet über
		// updateProfile im Speicher, und useAvatarUrl holt das Bild daraufhin
		// angemeldet nach. Gezeigt wird damit, was tatsächlich gespeichert wurde.
		http.put(TApi.STUDENT_AVATAR_UPLOAD, form)
			.then(({ data }) => {
				props.updateProfile({ ...data })
				toast.success(t('Avatar successfully updated'))
			})
			.finally(() => setLaedt(false))
	}

	const handleClean = () => {
		if (!props.avatarHashName) return

		setLaedt(true)
		http.delete(TApi.STUDENT_AVATAR_DELETE)
			.then(() => {
				toast.success(t('Avatar successfully deleted'))
				props.updateProfile({ avatarHashName: '' })
			})
			.finally(() => setLaedt(false))
	}

	return (
		<div className={styles.section}>
			<h1 className={styles.sectionTitle}>{t('Avatar photo')}</h1>
			<div className={styles.sectionContent}>
				<AvatarUploader
					src={avatarSrc}
					name={props.displayName}
					onClean={handleClean}
					onSelect={handleSelect}
					className={styles.avatarUploader}
					disabled={laedt || props.isTeacherStudentView}
				/>
			</div>
		</div>
	)
}

const mapStateToProps = state => ({
	avatarHashName: state.user.profile.avatarHashName,
	displayName: [state.user.profile.firstName, state.user.profile.lastName].filter(Boolean).join(' ')
})

const mapDispatchToProps = dispatch => ({
	updateProfile: data => dispatch(updateProfile(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(AvatarPhoto)
